
import { defineComponent, PropType } from 'vue'
import { RunStatus } from '~/types/types'
import { GeneralizedRunT } from '~/utils/runs'
import { runStatusIcon, runStatusIconColor, runStatusTagLabel } from '~/utils/ui'

export default defineComponent({
  name: 'RunStatusUIPill',
  props: {
    type: {
      type: String as PropType<'Code analysis' | 'SCA'>,
      default: 'Code analysis'
    },
    status: {
      type: String as PropType<GeneralizedRunT['status']>,
      default: RunStatus.Pass
    }
  },
  computed: {
    pillIcon(): string {
      return runStatusIcon(this.status)
    },
    pillIconColor(): string {
      return runStatusIconColor(this.status)
    },
    pillLabel(): string {
      return runStatusTagLabel(this.status)
    }
  }
})
